module.exports = __webpack_public_path__ + "static/media/logo.f69e0405.svg";